var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invoice-wrap-bg"},[_c('EditInvoiceUploadForm',{ref:"uploaded-invoice-edit-form",attrs:{"emit-submit":"","is-edit":""},on:{"updated":_vm.invoiceUpdated}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }